import Vue from 'vue'
import { truncate } from '~/helpers'

Vue.filter('truncate', (value, length = 50, clamp = '...') =>
  truncate(value, length, clamp)
)
